<template>
  <v-app>
    <div v-if="this.$route.name === 'homepage'">
      <div class="main-wrpper">
      <router-view></router-view>

      <!-- Footer -->
      <footer>
          <modal :scrollable="true"
                 name="terms-and-conditions"
                 @before-open="beforeOpen"
                 height="auto"
                 :minHeight="800"
                 width="80%">
              <div class="" id="termsModal" role="dialog">
                  <div class="">

                      <terms-and-conditions />
                      <div class="col-md-4 col-sm-4">
                          <div class="quicklinks">
                              <h3>INFORMATION</h3>

                              <ul>
                                  <li> <a href="javascript:void(0);" @click="showModalTerms()">Terms of Service</a> </li>
                                  <li>
                                      <a href="javascript:void(0);"
                                         @click="showPrivacyPolicy()">Privacy Policy</a>
                                  </li>
                              </ul>
                          </div>
                      </div>
                    </div>
              </div>
          </modal>
          <modal :scrollable="true"
                 name="privacy-policy"
                 @before-open="beforeOpen"
                 height="auto"
                 :minHeight="800"
                 width="80%">
              <div class="" id="privacyModal" role="dialog">
                  <div class="">

                      <privacy-policy />
                  </div>

                  <div class="col-md-4 col-sm-4">
                      <div class="social-icons">
                          <ul>
                              <li> <a href="#"><i class="fab fa-facebook-f"></i></a> </li>
                              <li> <a href="#"><i class="fab fa-instagram"></i></a> </li>
                              <li> <a href="#"><i class="fab fa-youtube"></i></a> </li>
                          </ul>

                          <p>Design & Developed by " Planitis DigitalQ " <br> All Rights Reserved</p>
                      </div>
                  </div>
              </div>
          </modal>
          <div class="container">
              <div class="row">
                  <div class="col-md-4 col-sm-12">
                      <div class="foot-logo">
                          <img src="images/logo.png" alt="">
                          <p>A comprehensive financial<br>services and maintenance <br>management platform</p>
                      </div>
                  </div>

                  <div class="col-md-4 col-sm-4">
                      <div class="quicklinks">
                          <h3>INFORMATION</h3>

                          <ul>
                              <li> <a href="javascript:void(0);" @click="showModalTerms()">Terms of Service</a> </li>
                              <li>
                                  <a href="javascript:void(0);"
                                     @click="showPrivacyPolicy()">Privacy Policy</a>
                              </li>
                          </ul>
                      </div>
                  </div>

                  <div class="col-md-4 col-sm-4">
                      <div class="social-icons">
                          <ul>
                              <li> <a href="#"><i class="fab fa-facebook-f"></i></a> </li>
                              <li> <a href="#"><i class="fab fa-instagram"></i></a> </li>
                              <li> <a href="#"><i class="fab fa-youtube"></i></a> </li>
                          </ul>

                          <p>Design & Developed by " Planitis DigitalQ " <br> All Rights Reserved</p>
                      </div>
                  </div>
              </div>

          </div>
      </footer>
            <!-- End Footer -->
      
      </div>  
    </div>
    <div v-else>
      <v-navigation-drawer
        v-if="currentUser"
        id="core-navigation-drawer"
        v-model="drawer"
        :rail="mini"
        color="#F8FAFD"
        mobile-breakpoint="960"
        width="200"
        class="main-navigation"
    :class="{'is-mini':mini}"
      >
        <side-menu v-if="isAdmin" :key="count" />
        <owner-menu v-if="isOwner" />

        <!--<v-list-item v-for="item in items" :key="item.title" link>
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>-->
      </v-navigation-drawer>
      
      <v-app-bar
      style="padding:0px"
         id="app-bar"
        color="#F8FAFD"
        flat
        height="30"
        padding="0"
      >
      <button
      class="btn btn-table"
      style="background-color:#F8FAFD;z-index:9999;margin-left: -16px!important;
    margin-top: 30px;
    border-left: 0;"
          icon
          @click.stop="mini = !mini"
        >
          <v-icon>mdi-chevron-double-right</v-icon>
          
        </button>

        <!-- <v-toolbar-title
          class="hidden-sm-and-down font-weight-light"
      v-text="$route.name"
        />-->

        <v-spacer />

        <v-menu
        v-if="false"
          bottom
          left
          offset-y
          origin="top right"
          transition="scale-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              min-width="0"
              elevation="1"
              color="#015A6C"
              fab
              dark
              small
              text
              v-bind="attrs"
              v-on="on"
            >
              <!--<v-badge color="red" overlap bordered>
              <template v-slot:badge>
                <span>5</span>
              </template>

              <v-icon>mdi-account</v-icon>
            </v-badge>-->
              <v-icon dark>mdi-account</v-icon>
            </v-btn>
          </template>

          <v-list :tile="false" nav>
            <div>
              <app-bar-item>
                <v-list-item-title
                  title="Login"
                  v-if="$store.state.authentication.loggedIn"
                  class="sidebar-nav-item"
                >
                  <router-link :to="{ name: 'buildings' }">Login</router-link>
                </v-list-item-title>
                <div v-else>
                  <v-list-item-title title="Logout">
                    {{ user.firstName }} {{ user.lastName }}
                  </v-list-item-title>
                  <v-divider></v-divider>

                  <v-list-item-title title="Logout"
                    ><a href="#" @click.prevent="logout"
                      >Logout</a
                    ></v-list-item-title
                  >
                </div>
               <!-- <v-list-item-title
                  title="Logout"
                  class="dropdown sidebar-nav-item"
                >
                  <a
                    href="#"
                    class="dropdown-toggle"
                    data-toggle="dropdown"
                    role="button"
                    aria-expanded="false"
                  >
                    English
                    <span class="caret"></span>
                  </a>
                  <ul class="dropdown-menu" role="menu">
                    <v-list-item-title title="Logout"
                      ><a href="/">Ελληνικά</a></v-list-item-title
                    >
                  </ul>
                </v-list-item-title>-->
                <v-list-item-title
                  title="Account"
                 
                  class="sidebar-nav-item"
                >
                  <router-link :to="{ name: 'account' }">Account</router-link>
                </v-list-item-title>
                <v-list-item-title
                  title="Users"
                  v-if="currentUser.role == 'Admin'"
                  class="sidebar-nav-item"
                >
                  <router-link :to="{ name: 'users' }">Users</router-link>
                </v-list-item-title>
               <!-- <v-list-item-title title="Logout" class="sidebar-nav-item"
                  ><a href="/#features">Features</a></v-list-item-title
                >
                <v-list-item-title title="Logout" class="sidebar-nav-item"
                  ><a href="/#pricelist">Pricelist</a></v-list-item-title
                >
                <v-list-item-title title="Logout" class="sidebar-nav-item"
                  ><a href="/">Support</a></v-list-item-title
                >-->
              </app-bar-item>
            </div>
          </v-list>
        </v-menu>
      </v-app-bar>

      <!--<nav-menu v-if="currentUser" />-->
      <v-main>
        <v-container style="background: #f8fafd;" fluid>
          <div style="display: flex; width: 100%;">
            <div
              style="
                width: 100%;
                background-color: #f8fafd;
                height: auto;
                min-height: 100vh;
              "
            >
              <router-view v-slot="{ Component }">
                <transition name="slide-fade" mode="out-in">
                  <component :is="Component" />
                </transition>
              </router-view>
            </div>
          </div>
        </v-container>
      </v-main>
    </div>
    <assistant-chat v-if="currentUser" />
  </v-app>
</template>

<script>
import { authenticationService } from "@/_services";
import { router, Role } from "@/_helpers";
import { EventBus } from "@/events";
import { mapState, mapMutations } from "vuex";
import AssistantChat from "@/components/AssistantChat.vue";
/* EventBus.$on('updated', clickCount => {
         this.buildingId = clickCount

     });*/
export default {
  name: "app",
  components: { AssistantChat },
  data() {
    return {
      currentUser: null,
      buildingId: 0,
      buildingName: "",
      renderComponent: true,
      count: 0,
      x: 0,
      drawerWasClosed: false,
    };
  },
  props: {},
  beforeCreate() {},
  watch: {
    drawer(val) {
      if (!val) {
        this.drawerWasClosed = true;
        setTimeout(() => {
          this.drawerWasClosed = false;
        }, 0);
      }
    },
    /* value(val) {
      this.$emit("update:buildingId", val);
    },
    buildingId(val) {
      this.value = val;
      alert(this.value);
      //this.fetchStatement();
    },*/
  },
  computed: {
    ...mapState(["drawer", "building", "mini"]),
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(val) {
        this.$store.commit("SET_DRAWER", val);
      },
    },
    mini: {
      get() {
        return this.$store.state.mini;
      },
      set(val) {
        this.$store.commit("SET_MINI", val);
      },
    },
    user() {
      return authenticationService.currentUserValue;
      //return this.$store.state.authentication.user;
      /* alert( this.$store.state.authentication.user)
                ;*/
    },
    showSideMenu() {
      if (this.isAdmin) {
        if (this.$route.params.buildingId) return true;
        return false;
      } else if (this.isOwner) {
        if (this.$route.params.propertyId) return true;
        return false;
      }
      return false;
    },
    isAdmin() {
      return (
        (this.currentUser && this.currentUser.role === Role.Admin) ||
        this.currentUser.role === Role.Management
      );
    },
    isOwner() {
      return this.currentUser && this.currentUser.role === Role.Owner;
    },
    computedBuilding() {
      return this.buildingId;
    },
    logged() {
      return this.isAdmin || this.isOwner;
    },
  },
  mounted() {},
  created() {
    authenticationService.currentUser.subscribe((x) => (this.currentUser = x));
    this.updatedHandler = function (payLoad) {
      this.buildingId = payLoad;
    };
    EventBus.$on("updated", this.updatedHandler);
    this.menuDrawerHandler = (drawer) => {
      this.drawer = drawer;
    };
    EventBus.$on("menuDrawerClicked", this.menuDrawerHandler);
  },
  beforeUnmount() {
    EventBus.$off("updated", this.updatedHandler);
    EventBus.$off("menuDrawerClicked", this.menuDrawerHandler);
  },
  methods: {
    ...mapMutations({
      setDrawer: "SET_DRAWER",
    }),

    getCoordinateX: function (event) {
      this.x = event.clientX;
    },
    showModalTerms: function () {
      this.$modal.show("terms-and-conditions");
    },
    showPrivacyPolicy: function () {
      this.$modal.show("privacy-policy");
    },
    showDisclaimer: function () {
      this.$modal.show("disclaimer");
    },
    forceRerender() {
      // Remove my-component from the DOM
      this.renderComponent = false;
    },
    logout() {
      authenticationService.logout();
      router.push("/login");
    },
    closeMenu: function () {
      if (this.drawer == true) {
        if (this.x > 242) {
          if (this.windowWidth < 1264) {
            this.drawer = !this.drawer;
            let drawer = this.drawer;
            EventBus.$emit("menuDrawerClicked", drawer);
          }
        }
      }
    },
  },
};
</script>
<style>
/*@import "../../node_modules/@syncfusion/ej2-base/styles/material.css";
@import "../../node_modules/@syncfusion/ej2-inputs/styles/material.css";
@import "../../node_modules/@syncfusion/ej2-vue-dropdowns/styles/material.css";
/*@import "../../node_modules/@syncfusion/ej2-buttons/styles/material.css";*/
</style>

<style>
/*** TRANSITIONS ***/
.fade-enter-from {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease-out;
}

.fade-leave-to {
  opacity: 0;
}

.slide-fade-enter-from {
  transform: translateX(10px);
  opacity: 0;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.2s ease;
}

.slide-fade-leave-to {
  transform: translateX(-10px);
  opacity: 0;
}

.slide-up-enter-from {
  transform: translateY(10px);
  opacity: 0;
}

.slide-up-enter-active {
  transition: all 0.2s ease;
}

.slide-up-move {
  transition: transform 0.8s ease-in;
}

.noDisplay {
  display: none;
}


</style>
